export type InventoryBuckets = "overstock" | "healthy" | "excess";

export const inventoryBucketValues: InventoryBuckets[] = ["healthy", "excess", "overstock"];

export interface InventoryStats {
  report_date: string;
  health: InventoryBuckets;
  count: number;
  forecast_units: number;
  total_units: number;
  forecast_revenue: number;
  total_sales: number;
  cost: number;
}

export interface PlanData {
  report_date: string;
  health: string;
  plan_id: number;
  plan_name: string;
  category_id: number;
}

export interface GroupedStats {
  [report_date: string]: {
    health: Record<
      InventoryBuckets,
      {
        count: number;
        forecast_units: number;
        total_units: number;
        forecast_revenue: number;
        total_sales: number;
        cost: number;
      }
    >;
  };
}
